import React from "react";
import Menu from "./Components/menu";
import Banner from "./Components/banner";
import Ferramentas from "./Components/ferramentas";
import DashboardsInfo from "./Components/dashboardsInfo";
import Planos from "./Components/planos";
import Footer from "./Components/footer";
import Cta from './Components/Cta'; // Ajuste o caminho se necessário

function Site() {
    return <div>
        <Menu />
        <Banner />
        <Ferramentas />
        <DashboardsInfo />
        <Cta />
        <Planos />
        <Footer />
    </div>;
}

export default Site;